/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

/*
 * Protected Pages with Authentication and accepted Terms of Service
 */

import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { Auth } from 'aws-amplify';

import { setLang, setAuth, setUser } from '../../redux/actions';

const mapStateToProps = (state) => {
	return {
		user: state.user,
	};
};

class ProtectedRoute extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isAuthenticated: true,
			resignToS: false,
		};
	}

	componentDidMount() {
		Auth.currentAuthenticatedUser()
			.then(() => {
				this.setState({ isAuthenticated: true });
				this.props.setAuth(true);

				Auth.currentUserInfo()
					.then((user) => {
						this.props.setUser(user);
						this.props.setLang(user.attributes.locale);
					})
					.catch((err) => {
						console.log(err);

						this.setState({ isAuthenticated: false });
						this.props.setAuth(false);
						this.props.setUser(null);
					});
			})
			.catch((err) => {
				if (err !== 'not authenticated') console.log(err);

				this.setState({ isAuthenticated: false });
				this.props.setAuth(false);
				this.props.setUser(null);
			});
	}

	render() {
		/*
		 * Route SingIn Page (loginPath) and Terms of Service (tosPath)
		 */
		const loginPath = '/';

		/*
		 * "path" of the requesting component to redirect back
		 */
		const redirectTo = this.props.path.replace('/', '') || null;

		/*
		 * Target component
		 */
		const Component = this.props.component;

		/*
		 * If user NOT signed in redirect to "loginPath" - add QueryParam redirectTo
		 * If user NOT accepted the Terms of Service redirect to "tosPath" - add QueryParam redirectTo
		 * Otherwise route to target component
		 */
		return !this.state.isAuthenticated ? <Redirect to={{ pathname: loginPath, search: `redirect=${redirectTo}` }} push={true} /> : <Component />;
	}
}

export default connect(mapStateToProps, { setAuth, setUser, setLang })(ProtectedRoute);
